import { Sites } from '@labradorsports/constants';

import Basketball from './basketball.js';
import Football from './football.js';
import Lacrosse from './lacrosse.js';

export default {
    [Sites.lacrosselab]: Lacrosse,
    [Sites.hoopslab]: Basketball,
    [Sites.footballlab]: Football,
};
